// Слайдер услуг и мобильный toggle
export function initServicesSlider() {
  let servicesSwiperEl = document.querySelector('.services__swiper');
  let isInited = false;

  function buildParams() {
    const w = window.innerWidth;
    const isDesktop = w >= 1400;
    return {
      loop: !isDesktop,
      centeredSlides: w < 480,
      slidesPerView: 1,
      spaceBetween: 10,
      watchSlidesProgress: true,
      observeParents: true,
      observer: true,
      resizeObserver: true,
      speed: 450,
      breakpoints: {
        375: { slidesPerView: 1.4, centeredSlides: true },
        640: { slidesPerView: 2, centeredSlides: false, spaceBetween: 10 },
        900: { slidesPerView: 3, spaceBetween: 15 },
        1200: { slidesPerView: 4, spaceBetween: 15 },
        1400: { slidesPerView: 5, spaceBetween: 15, loop: false },
      },
      navigation: { prevEl: '.services__prev', nextEl: '.services__next' },
      pagination: { el: '.services__pagination', clickable: false },
    };
  }

  function initOrUpdateServicesSlider() {
    if (!servicesSwiperEl) return;
    const params = buildParams();
    if (isInited && servicesSwiperEl.swiper) {
      servicesSwiperEl.swiper.destroy(true, true);
      isInited = false;
    }
    Object.assign(servicesSwiperEl, params);
    servicesSwiperEl.initialize();
    isInited = true;
    servicesSwiperEl.classList.add('is-active');
  }

  function initMobileSlideToggle() {
    const slides = document.querySelectorAll('.services__slide-content');
    slides.forEach(slide => {
      slide.addEventListener('click', e => {
        const isDesktop = window.innerWidth >= 1400;
        if (isDesktop) return;
        if (!slide.classList.contains('is-open')) {
          slides.forEach(s => s.classList.remove('is-open'));
        }
        slide.classList.toggle('is-open');
        e.stopPropagation();
      });
    });
    document.addEventListener('click', e => {
      if (window.innerWidth >= 1400) return;
      if (!e.target.closest('.services__slide-content')) {
        document.querySelectorAll('.services__slide-content.is-open').forEach(s => s.classList.remove('is-open'));
      }
    });
  }

  function updateServicesNav() {
    const prevBtn = document.querySelector('.services__prev');
    const nextBtn = document.querySelector('.services__next');
    if (!prevBtn || !nextBtn) return;
    const isWide = window.innerWidth > 1400;
    if (isWide) {
      prevBtn.setAttribute('aria-disabled', 'true');
      prevBtn.setAttribute('tabindex', '-1');
      nextBtn.setAttribute('aria-disabled', 'true');
      nextBtn.setAttribute('tabindex', '-1');
    } else {
      prevBtn.removeAttribute('aria-disabled');
      prevBtn.setAttribute('tabindex', '0');
      nextBtn.removeAttribute('aria-disabled');
      nextBtn.setAttribute('tabindex', '0');
    }
  }

  function handleResize() {
    initOrUpdateServicesSlider();
    updateServicesNav();
    if (window.innerWidth >= 1400) {
      document.querySelectorAll('.services__slide-content.is-open').forEach(s => s.classList.remove('is-open'));
    }
  }

  initOrUpdateServicesSlider();
  updateServicesNav();
  initMobileSlideToggle();
  window.addEventListener('resize', handleResize);
}
